import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

const Body = styled.div`
  background-color: rgb(11, 0, 26);
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const Para = styled.p`
  margin-top: 10%;
  font-weight: 800;
  color: #fff;
  letter-spacing: 6;
  font-size: 40px;

  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

const BackButton = styled.button`
  background: rgba(0, 0, 0, 0)
    linear-gradient(90deg, rgb(229, 0, 255) 0%, rgb(130, 0, 255) 100%) repeat
    scroll 0% 0%;
  font-family: "Poppins";
  margin-top: 0.9rem;
  margin-right: 0.6rem;
  text-transform: uppercase;
  height: auto;
  color: rgb(255, 255, 255);
  transition: all ease 0.5s;
  text-decoration: none;
  white-space: normal;
  width: 10rem;
  text-align: center;
  line-height: 35px;
  letter-spacing: 2px;
  font-weight: 500;
  font-size: 14px;
  box-shadow: rgb(103 0 255 / 40%) 0px 10px 60px 0px;
  padding: 4px 0px;
  border-radius: 300px;
  visibility: visible;
`;

const PageNotFound = () => {
  const navigate = useNavigate();

  return (
    <Body>
      <div>
        <img
          src="https://www.o1codingclub.in/static/media/logo.a2fbdf89b6fd77800ec883567f238e84.svg"
          alt="logo"
          height="300px"
          width="300px"
        />
      </div>
      <div>
        <Para>Error 404 Page not found</Para>
      </div>
      <div>
        <BackButton onClick={() => navigate("/")}>Go to Home</BackButton>
      </div>
    </Body>
  );
};

export default PageNotFound;
